// extracted by mini-css-extract-plugin
export default {"text-para":"ShowMoreText_text-para__wXhVk","collapsed":"ShowMoreText_collapsed__9xe84","expanded":"ShowMoreText_expanded__je92A","toggle-button":"ShowMoreText_toggle-button__NcOi6"};